const MAX_API_PAGINATION_PAGE_NUMBER_LIMIT = 1000;
const API_NAME = 'SFMobile';

const HTTP_AUTHORIZATION_METHOD = {
  BEARER: 'Bearer',
}

export {
  MAX_API_PAGINATION_PAGE_NUMBER_LIMIT,
  HTTP_AUTHORIZATION_METHOD,
  API_NAME,
};
